export const MEDIA_QUERIES = {
  mobileSmall: '(max-width: 449px)',
  mobile: '(max-width: 599px)',
  tablet: '(max-width: 1023px)',
};
